import { jsx } from "react/jsx-runtime";
import { Children } from "react";
import { INVALID_PROPS_ERROR, COMPONENT_NAME } from "./constants.js";
import { ParentWrapper, ChildWrapper } from "./styles.js";
const Strip = ({
  children,
  sx,
  uniqueId,
  ...rest
}) => {
  if (!children) {
    console.error(INVALID_PROPS_ERROR);
    return null;
  }
  return /* @__PURE__ */ jsx(ParentWrapper, { sx, ...rest, "data-testid": uniqueId, children: Children.map(children, (child, index) => {
    return /* @__PURE__ */ jsx(ChildWrapper, { children: child }, index);
  }) });
};
Strip.displayName = COMPONENT_NAME;
export {
  Strip
};
